import { createPortal } from 'react-dom'
import './index.css'

export function AnnouncementModal({ show = false, setShow }) {
  return (
    createPortal(
      show ? (
        <div className='aa-modal-overlay' style={{ display: show ? 'flex' : 'none' }}>
          <div className='aa-announcement-modal'>
            <div className='aa-close-btn' onClick={()=>setShow(false)}>×</div>
            <div className='aa-modal-title'>重要公告</div>
            <div className='aa-modal-content'>
              <p>
                本平台关闭办理，办理请到福建省人力资源和社会保障政务服务平台
                （<a href="https://zwfw.rst.fujian.gov.cn">https://zwfw.rst.fujian.gov.cn</a>）</p>
            </div>
            <button className='aa-confirm-btn' onClick={() => setShow(false)}>我知道了</button>
          </div>
        </div>
      ) : null,
      document.body
    )
  )
}